import { FC, useEffect, useState } from "react";
import React from "react";
import "./DataProtectionNotice.css";

const DataProtectionNotice: FC<any> = (props) => {
  const [htmlFileName, setHtmlFileName] = useState<string>("");
  const resizeIFrame = (e: any) => {
    e.target.style.height = e.target.contentDocument.body.scrollHeight + "px";
  };

  const reload = () => {
    window.location.href = window.location.href;
  };

  useEffect(() => {
    let htmlFile = `/vhc-dpn/en.html`;
    setHtmlFileName(htmlFile);

    window.addEventListener("resize", reload);
    return () => window.removeEventListener("resize", reload);
  });

  return (
    <div className="term-container">
      <iframe
        src={htmlFileName}
        width="100%"
        id="iframe"
        onLoad={(e) => resizeIFrame(e)}
      ></iframe>
    </div>
  );
};
export default DataProtectionNotice;
